export class KebabCaseTracker {
  private map: Map<string, string> = new Map();

  add(raw: string): string {
    const kebab = this.toKebabCase(raw);
    this.map.set(raw, kebab);
    return kebab;
  }

  addAll(rawStrings: string[]): void {
    rawStrings.forEach((raw) => {
      this.add(raw);
    });
  }

  getKebab(raw: string): string | undefined {
    return this.map.get(raw);
  }

  getRawByKebab(kebab: string): string[] {
    // eslint-disable-next-line id-length
    return [...this.map.entries()].filter(([, v]) => v === kebab).map(([k]) => k);
  }

  entries(): [string, string][] {
    return [...this.map.entries()];
  }

  // eslint-disable-next-line class-methods-use-this
  private toKebabCase(str: string): string {
    return str
      .normalize('NFKD')
      .replace(/[^a-zA-Z0-9\s]/g, '')
      .trim()
      .toLowerCase()
      .replace(/\s+/g, '-');
  }
}
